<template>
  <div class="start flex flex-wrap -mx-2">
    <div v-if="!isValidHost">{{ errorMessage }}</div>
    <div v-if="isValidHost" class="w-full" itemscope itemtype="https://schema.org/Review">
      <h1>Die aktuellsten Kundenbewertungen</h1>

      <div itemprop="itemReviewed" itemscope itemtype="https://schema.org/Restaurant">
        <img class="w-16 h-16 mr-1 float-left" itemprop="image" :src="hostdescription.logo" :alt="''"/>
        <span class="font-bold" itemprop="name">{{ hostdescription.name }}</span><br />
        <span itemprop="servesCuisine">{{ hostdescription.foodtype }}</span>
        <span class="hidden" itemprop="telephone">{{ hostdescription.phone }}</span>
        <span class="hidden" itemprop="address">{{ hostdescription.address }}</span>
      </div>

      <div class="bg-grey-lightest border-l-4 border-green p-4 mt-8 text-sm" role="alert">
        <p v-html="summary"></p>
      </div>

      <p class="mb-2 text-sm leading-tight text-grey-darker pt-6">In Schulnoten</p>
      <div v-for="review in reviews" :key="review.id" class="bg-white shadow-lg rounded-lg overflow-hidden mb-4" itemprop="reviewRating" itemscope itemtype="https://schema.org/Rating">
        <div class="sm:flex px-6 py-4">
          <div class="sm:text-left sm:flex-grow">
            <div class="mb-4">
              <p class="text-sm leading-tight text-grey-darker mb-4">{{ review.build }} | Gesamt: <span itemprop="ratingValue">{{ review.fiveStarTranslation }}</span> von 5.0</p>
              <p v-if="review.content != ''" class="text-xl leading-tight" itemprop="reviewBody">{{ review.content }}</p>
              <p v-if="review.comment != null" class="text-xl leading-tight "><strong>Kommentar des Anbieters:</strong> {{ review.comment }}</p>
              <div class="flex flex-wrap md:flex-no-wrap w-full mt-4">
                <div class="w-full md:w-1/3 flex">
                  <div class="md:mr-4 w-48">Qualität:</div>
                  <rating :value="review.quality" mode="school"></rating>
                </div>
                <div class="w-full md:w-1/3 flex">
                  <div class="md:mx-4 w-48">Lieferzeit:</div>
                  <rating :value="review.time" mode="school"></rating>
                </div>
                <div class="w-full md:w-1/3 flex">
                  <div class="md:mx-4 w-48">Preis/Leistung:</div>
                  <rating :value="review.price" mode="school"></rating>
                </div>
              </div>
              <div v-if="review.image" class="pt-4">
                <img :src="review.image" alt="Kundenfoto des Essens" class="customerImage" @click="e => e.target.classList.toggle('customerImage--full')" />
              </div>
              <p class="pt-2 text-sm">
                <template v-if="review.username != null">
                  von
                  <span itemprop="author" itemscope itemtype="https://schema.org/Person">
                    <span itemprop="name">{{ review.username }}<template v-if="review.userlocation"> aus {{ review.userlocation }}</template></span>
                  </span>,
                </template>
                <template v-if="review.ordervalue > 0">
                  Bestellwert
                  <template v-if="review.ordervalue < 10">unter 10 €</template>
                  <template v-if="review.ordervalue >= 10 && review.ordervalue <= 20">zwischen 10 und 20 €</template>
                  <template v-if="review.ordervalue > 20 && review.ordervalue <= 50">zwischen 20 und 50 €</template>
                  <template v-if="review.ordervalue > 50 && review.ordervalue <= 100">zwischen 50 und 100 €</template>
                  <template v-if="review.ordervalue > 100">über 100 €</template>
                </template>
              </p>
              <div itemprop="publisher" itemscope itemtype="https://schema.org/Organization">
                <meta itemprop="name" content="foodi.de">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import endpoints from '../../endpoints'
import axios from 'axios'
import Rating from '../../components/Rating.vue'

export default {
  name: 'Reviews',

  data () {
    return {
      hostdescription: {},
      reviews: {},
      summary: 'wird geladen...',
      isValidHost: false,
      errorMessage: ''
    }
  },

  components: {
    'rating': Rating
  },

  created () {
    this.getHostdescription()
    this.getRatings()
    this.getRatingSummary()
  },

  methods: {
    getHostdescription () {
      axios.post(endpoints.hostdescription, {
        'hostUrl': this.$route.params.hostUrl
      })
        .then(({data}) => {
          if (typeof data.error !== 'string') {
            this.hostdescription = data
            this.isValidHost = true
            this.errorMessage = ''
          } else {
            this.errorMessage = data.error
          }
        })
    },

    getRatings () {
      axios.post(endpoints.ratings, {
        'hostUrl': this.$route.params.hostUrl
      })
        .then(response => {
          this.reviews = response.data
        })
    },

    getRatingSummary () {
      axios.post(endpoints.ratingsummary, {
        'hostUrl': this.$route.params.hostUrl
      })
        .then(response => {
          this.summary = response.data.summary
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .customerImage {
    width: 100%;
    max-width: 300px;
    border-radius: 5px;
    cursor: pointer;

    &--full {
      max-width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/review/index.vue